var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.loading,
      expression: "!$store.state.loading"
    }]
  }, [_c('div', {
    staticClass: "container px-3 px-md-0 pb-4 pt-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "mb-4 text-info"
  }, [_vm._v("About This Program")]), !_vm.entityProgram.Narrative1 && !_vm.entityProgram.Narrative2 && !_vm.entityProgram.Narrative3 ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" Information about this program has not been submitted. Contact the Institution of Higher Education for more information. ")]) : _vm._e(), _vm.entityProgram.Narrative1 ? _c('div', {
    staticClass: "pb-2"
  }, [_c('h5', [_vm._v("What Makes Us Special - Undergraduate")]), _c('ul', [_vm.entityProgram.Thing1 && _vm.entityProgram.Thing1.length > 0 ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Thing1)
    }
  }) : _vm._e(), _vm.entityProgram.Thing2 && _vm.entityProgram.Thing2.length > 0 ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Thing2)
    }
  }) : _vm._e(), _vm.entityProgram.Thing3 && _vm.entityProgram.Thing3.length > 0 ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Thing3)
    }
  }) : _vm._e()])]) : _vm._e(), _vm.entityProgram.Narrative4 ? _c('div', {
    staticClass: "pb-2"
  }, [_c('h5', [_vm._v("What Makes Us Special - Graduate")]), _c('ul', [_vm.entityProgram.Thing4 && _vm.entityProgram.Thing4.length > 0 ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Thing4)
    }
  }) : _vm._e(), _vm.entityProgram.Thing5 && _vm.entityProgram.Thing5.length > 0 ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Thing5)
    }
  }) : _vm._e(), _vm.entityProgram.Thing6 && _vm.entityProgram.Thing6.length > 0 ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Thing6)
    }
  }) : _vm._e()])]) : _vm._e(), _vm.entityProgram.Narrative2 ? _c('div', {
    staticClass: "py-3"
  }, [_c('h5', [_vm._v("Our Student Teaching & Clinical Experiences")]), _c('div', {
    staticClass: "card-text",
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Narrative2)
    }
  })]) : _vm._e(), _vm.entityProgram.Narrative3 ? _c('div', {
    staticClass: "pt-3"
  }, [_c('h5', [_vm._v("How We Prepare for the Classroom")]), _c('div', {
    staticClass: "card-text",
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.Narrative3)
    }
  })]) : _vm._e(), _vm.entityProgram.Narrative3 ? _c('div', {
    staticClass: "pt-3"
  }, [_c('h5', [_vm._v("Additional Context for Reauthorization Status")]), _c('div', {
    staticClass: "card-text",
    domProps: {
      "innerHTML": _vm._s(_vm.entityProgram.ContextForReauthorization)
    }
  })]) : _vm._e()])])]), _c('div', {
    staticClass: "col-lg-4 mt-lg-0 mt-4 d-flex flex-column"
  }, [_c('div', {
    staticClass: "card flex-fill"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "text-info mb-4"
  }, [_vm._v("Contact Us")]), _vm.entityProgram.Url ? _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v("Website")]) : _vm._e(), _vm.entityProgram.Url ? _c('a', {
    attrs: {
      "href": _vm.entityProgram.Url
    }
  }, [_vm._v(_vm._s(_vm.entityProgram.Url))]) : _vm._e(), _vm.entityProgram.ContactName ? _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v("Contact")]) : _vm._e(), _vm.entityProgram.ContactName ? _c('span', [_vm._v(" " + _vm._s(_vm.entityProgram.ContactName) + " "), _vm.entityProgram.ContactEmail ? _c('span', [_c('br'), _c('a', {
    attrs: {
      "href": `mailto:${_vm.entityProgram.ContactEmail}`
    }
  }, [_vm._v(_vm._s(_vm.entityProgram.ContactEmail))])]) : _vm._e(), _vm.entityProgram.ContactPhone ? _c('span', [_c('br'), _vm._v(" " + _vm._s(_vm.entityProgram.ContactPhone) + " ")]) : _vm._e()]) : _vm._e(), _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v("Address")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://www.google.com/maps/search/?api=1&query=' + `${encodeURIComponent(`${_vm.entity.StreetAddress}, ${_vm.entity.State} ${_vm.entity.City} ${_vm.entity.Zip}${_vm.entity.ZipPlus4 ? `-${_vm.entity.ZipPlus4}` : ''}`)}`
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.entity.AdditionalName ? `${_vm.entity.AdditionalName}<br/>` : '')
    }
  }), _vm._v(" " + _vm._s(_vm.entity.StreetAddress) + ", "), _c('br'), _vm._v(" " + _vm._s(_vm.entity.City) + " " + _vm._s(_vm.entity.State) + " " + _vm._s(_vm.entity.Zip) + _vm._s(_vm.entity.ZipPlus4 ? `-${_vm.entity.ZipPlus4}` : "") + " ")])])]), _c('div', {
    staticClass: "card mt-4 flex-fill"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "text-info mb-4"
  }, [_vm._v("Details")]), _vm._m(0), _c('ul', {
    staticClass: "list-unstyled mt-2"
  }, [_c('li', {
    style: {
      opacity: _vm.entityProgram.ProgramTypes.Traditional ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square': _vm.entityProgram.ProgramTypes.Traditional,
      'text-dark far fa-square ': !_vm.entityProgram.ProgramTypes.Traditional
    }
  }), _vm._v(" Traditional ")]), _c('li', {
    style: {
      opacity: _vm.entityProgram.ProgramTypes.Alternative ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square': _vm.entityProgram.ProgramTypes.Alternative,
      'text-dark far fa-square': !_vm.entityProgram.ProgramTypes.Alternative
    }
  }), _vm._v(" Alternative ")]), _c('li', {
    style: {
      opacity: _vm.entityProgram.ProgramTypes.Residency ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square ': _vm.entityProgram.ProgramTypes.Residency,
      'text-dark far fa-square ': !_vm.entityProgram.ProgramTypes.Residency
    }
  }), _vm._v(" Residency ")]), _c('li', {
    style: {
      opacity: _vm.entityProgram.ProgramTypes.NonResidency ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square ': _vm.entityProgram.ProgramTypes.NonResidency,
      'text-dark far fa-square ': !_vm.entityProgram.ProgramTypes.NonResidency
    }
  }), _vm._v(" Non Residency ")])]), _vm._m(1), _c('ul', {
    staticClass: "list-unstyled mt-2"
  }, [_c('li', {
    style: {
      opacity: _vm.entityProgram.PostSecondaryLevels.Undergraduate ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square ': _vm.entityProgram.PostSecondaryLevels.Undergraduate,
      'text-dark far fa-square ': !_vm.entityProgram.PostSecondaryLevels.Undergraduate
    }
  }), _vm._v(" Undergraduate ")]), _c('li', {
    style: {
      opacity: _vm.entityProgram.PostSecondaryLevels.Graduate ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square ': _vm.entityProgram.PostSecondaryLevels.Graduate,
      'text-dark far fa-square ': !_vm.entityProgram.PostSecondaryLevels.Graduate
    }
  }), _vm._v(" Graduate ")])]), _vm._m(2), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l(_vm.entityProgram.ProgramLengths, function (duration, index) {
    return _c('li', {
      key: index,
      staticClass: "d-flex flex-column mt-2"
    }, [_vm._v(" " + _vm._s(duration.SemesterLength + " Semesters")), _vm.entityProgram.ProgramLengths.length > 1 ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.getDurationDescription(duration)))]) : _vm._e()]);
  }), 0), _vm._m(3), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "d-flex flex-column mt-2"
  }, [_vm._v(" " + _vm._s(_vm.programSize) + " ")])]), _vm._m(4), _c('ul', {
    staticClass: "list-unstyled mt-2"
  }, [_c('li', {
    style: {
      opacity: !_vm.entityProgram.PrivateInd ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square ': !_vm.entityProgram.PrivateInd,
      'text-dark far fa-square ': _vm.entityProgram.PrivateInd
    }
  }), _vm._v(" Public ")]), _c('li', {
    style: {
      opacity: _vm.entityProgram.PrivateInd ? '' : '.5'
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: {
      'text-info fas fa-check-square ': _vm.entityProgram.PrivateInd,
      'text-dark far fa-square ': !_vm.entityProgram.PrivateInd
    }
  }), _vm._v(" Private ")])])])])])]), _c('h4', {
    staticClass: "text-secondary mt-5 pb-4"
  }, [_vm._v("Data Snapshots")]), _c('div', {
    staticClass: "card mb-5"
  }, [_vm._m(5), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "px-4 py-3 card-body"
  }, [_c('pbi-tile', {
    attrs: {
      "height-ratio": 0.6,
      "page-name": _vm.snapShot1_page,
      "filters": _vm.snapShot1_filters
    }
  }), _c('div', {
    staticClass: "d-flex flex-column flex-md-row mt-md-1",
    attrs: {
      "data-toggle": "buttons",
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn flex-fill flex-shrink-0",
    class: `${_vm.snapShot1_page === _vm.snapshotPages.Gender ? 'btn-primary' : 'btn-outline-primary'}`,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.snapShot1_page = _vm.snapshotPages.Gender;
      }
    }
  }, [_vm._v(" Gender ")]), _c('button', {
    staticClass: "btn my-md-0 my-2 mx-md-1 flex-fill text-nowrap flex-shrink-0",
    class: `${_vm.snapShot1_page === _vm.snapshotPages.RaceEthnicity ? 'btn-primary' : 'btn-outline-primary'}`,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.snapShot1_page = _vm.snapshotPages.RaceEthnicity;
      }
    }
  }, [_vm._v(" Race/Ethnicity ")]), _c('button', {
    staticClass: "btn flex-fill flex-shrink-0",
    class: `${_vm.snapShot1_page === _vm.snapshotPages.Demographic ? 'btn-primary' : 'btn-outline-primary'}`,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.snapShot1_page = _vm.snapshotPages.Demographic;
      }
    }
  }, [_vm._v(" Socio-economic and First Generation ")])])], 1)]), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "divider d-block d-lg-none"
  }), _c('div', {
    staticClass: "card-body pl-lg-0 py-4 py-lg-3"
  }, [_c('h4', {
    staticClass: "mb-4 text-info d-none d-lg-block"
  }, [_vm._v(_vm._s(_vm.cycle.IPPCycleYear) + " Candidate Demographics")]), _c('h5', [_vm._v("What does this mean?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" The percentage or number of candidates that enter the preparation program by gender, race/ethnicity, socio-economic and first generation subgroups. ")]), _c('h5', {
    staticClass: "mt-4"
  }, [_vm._v("Why is it included?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("It is important that programs recruit and train a strong, diverse cohort of candidates.")])])])])]), _c('div', {
    staticClass: "card mb-5"
  }, [_vm._m(6), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "px-4 py-3 card-body"
  }, [_c('pbi-tile', {
    attrs: {
      "height-ratio": 0.6,
      "page-name": _vm.snapshotPages.TrendingEnrollment,
      "filters": _vm.snapShot2_filters
    }
  })], 1)]), _vm._m(7)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v(" Program Type(s) "), _c('div', {
    staticClass: "d-inline text-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "There are three possible program types: traditional (consists of coursework, clinicals, and student teaching),\n                                          alternative (a 2-year format for candidates that already hold a bachelor's degree. It includes coursework and working\n                                          as a teacher of record for 2 years ), and residency (consists of coursework and clinical placements throughout the\n                                          duration of the program)."
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v(" Program Level(s) "), _c('div', {
    staticClass: "d-inline text-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Programs are offered within undergraduate and graduate degree programs. "
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v(" Program Length(s) "), _c('div', {
    staticClass: "d-inline text-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Program Length in Semesters"
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v(" Program Size "), _c('div', {
    staticClass: "d-inline text-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Avg. # of Completers over the past 5 years"
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h5', {
    staticClass: "mt-4 mb-1"
  }, [_vm._v(" Institution Type(s) "), _c('div', {
    staticClass: "d-inline text-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Institutions in the state are either public or private."
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header bg-transparent d-lg-none d-block"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("Candidate race and ethnicity")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header bg-transparent d-lg-none d-block"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v("Enrollment/Completers over Time")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "divider d-block d-lg-none"
  }), _c('div', {
    staticClass: "card-body pl-lg-0 py-4 py-lg-3"
  }, [_c('h4', {
    staticClass: "mb-4 text-info d-none d-lg-block"
  }, [_vm._v("Enrollment/Completers over Time")]), _c('h5', [_vm._v("What does this mean?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("The number of individuals that enroll and complete the program in the last five years.")]), _c('h5', {
    staticClass: "mt-4"
  }, [_vm._v("Why is it included?")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" It is important to understand the number of individuals that enroll in a preparation program and the number of individuals that complete a program in a given year. ")])])]);
}];
export { render, staticRenderFns };